import { createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit"
import { create_province, get_provinces } from "../actions/provinceAction"
import { toast } from "react-toastify"

const initial_state ={
    isLoading:false,
    isSuccess:false,
    isError:false,
    provinces:[],
    error_message:""
}
const create_province_slice = createSlice({
    name:"province",
    initialState:initial_state,
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(create_province.fulfilled,state=>{
            state.isSuccess=true
            // toast("Province added")
        })
        .addCase(get_provinces.fulfilled,(state,action)=>{
            state.provinces= action.payload.data
        })
        .addMatcher(isPending(create_province,get_provinces),state=>{
            state.isLoading=true
            state.isSuccess=false
            state.isError=false
        })
        .addMatcher(isRejected(create_province,get_provinces),(state,action)=>{
            state.isError=true
            state.isSuccess=false
            state.isLoading=false
            state.error_message= action.payload
        })
        .addMatcher(isFulfilled(create_province,get_provinces),state=>{
            state.isLoading=false
            state.isSuccess=true
            state.isError=false
        })
    }
})

export default create_province_slice.reducer